module.exports = __webpack_public_path__ + "static/img/pic-banner-contactus@2x.d53a942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-banner-contactus@2x.png
// module id = 983
// module chunks = 0